/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-14 19:46:58
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-06-30 00:02:49
 */
/*
 * 员工相关接口
 */
import request from '../request'
import { ILoginParams, LoginCheck } from '../model'

enum Api {
  LOGIN_API = '/user/login',
  LOGOUT_API = '/user/loginOut',
  GET_MENU_LIST = '/menu/currentUserOneAndTwoMenus',
  GET_TAB_OR_BUTTON_LIST = '/menu/currentUserThreeAndFourMenus'
}

export default class AjaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: ILoginParams): Promise<any> {
    return request.post(Api.LOGIN_API, data)
  }
  /**
   * 发送验证码
   * @param data
   * @returns
   */
  static sendEmail(data: any): Promise<any> {
    return request.post('/captcha/send', data)
  }
  /**
   * 忘记密码
   * @param data
   * @returns
   */
  static forgetPwd(data: ILoginParams): Promise<any> {
    return request.post('/user/forgetPwd', data)
  }
  /**
   * 设备验证
   * @param data
   * @returns
   */
  static checkNewDevice(data: LoginCheck | undefined): Promise<any> {
    return request.post('/user/checkNewDevice', data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.get(Api.LOGOUT_API)
  }

  /**
   * 获取登录人菜单权限
   * @returns
   */
  static getMenuList(): Promise<any> {
    return request.get(Api.GET_MENU_LIST)
  }

  /**
   * 获取tabList buttonList
   * @returns
   */
  static getTabOrButtonList(): Promise<any> {
    return request.get(Api.GET_TAB_OR_BUTTON_LIST)
  }
}
